import React from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import LazyLoad from "react-lazyload";
import NKRHeader from "../Component/NKRHeader";
import NKRFooter from "../Component/NKRFooter";
const SafetySecurity = () => {
  useEffect(() => {
    document.title = "Safety & Security -  Gayatri International School";
  }, []);
  return (
    <>
      <NKRHeader />
      <section className="page-header-fb innerslide">
        <div className="innerslide">
          <LazyLoad>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/innerslide1.gif"
              className="img-fluid"
            />
          </LazyLoad>{" "}
        </div>
        <div className="page-header__inner">
          <h2>Safety & Security</h2>
          <ul className="thm-breadcrumb list-unstyled ml-0">
            <li>
              <Link to="/Nekhpur/Home">Home</Link>
            </li>
            <li>|</li>
            <li>Facilities</li>
            <li>|</li>
            <li>Safety & Security</li>
          </ul>
        </div>
      </section>
      <section className="innerbody">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <ul className="mainlist">
                <li>
                  The school focuses prime importance to the safety and security
                  of students at school.{" "}
                </li>{" "}
                <li>
                  The school has installed fire-safety equipmentthat meets the
                  stringent quality standards.{" "}
                </li>{" "}
                <li>
                  The school premises is manned by trained security personnel to
                  watch the entry and exit of people.{" "}
                </li>{" "}
                <li>
                  As an additional measure of safety the school is monitored
                  using CCTV cameras installed at vantage points in order to
                  ensure that there is no breach of security.{" "}
                </li>{" "}
                <li>
                  Having an adult around is essential to avoid getting
                  trapped,to prevent serious panic situations for the school
                  faculty and the parents.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <NKRFooter />
    </>
  );
};

export default SafetySecurity;
